module.exports = __webpack_public_path__ + "img/west.367fd18e.png";